import React, { useState } from 'react'
import { AiOutlineCalendar } from 'react-icons/ai'
import { IoKeyOutline } from 'react-icons/io5'
import { SiAcademia } from 'react-icons/si'
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import NewFormWizard from '../../../components/formWizard/NewFormWizard'
import Layout from '../../../components/layouts/Layout'
import { storeEventData } from './slice/eventAction'
import LocalStorage from '../../../hook/LocalStorage';
import http from '../../../config/BaseUrl';
import { eventCreateReset } from './slice/createEventSlice';

const EventSummary = () => {
    const {
        eventId,
        isLoading,
        feature,
        event_info,
        social,
        event_option,
        email,
        sms_sharing,
        digital_prop,
        micro_site,
        photo_template_frame,
        filters
    } = useSelector(state => state.createEvent)
    const dispatch = useDispatch()
    const history = useHistory()
    const { user } = LocalStorage()
    const [loading, setLoading] = useState(false)

    const handelPayWithSubmitEvent = (e) => {
        e.preventDefault();
        if (user && user.membership.package_type === 'single') {
            history.push('/event/device')
        }
    }

    const handelSubmitEvent = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            await http.post(`event/store/${eventId}`).then((res) => {
                if (res.data.status === true) {
                    setLoading(false)
                    dispatch(eventCreateReset())
                    localStorage.removeItem("persist:root")
                    history.push('/event#live')
                }
            }).catch((err) => setLoading(false))
        } catch (error) {

        }
    }

    return (
        <Layout>
            <NewFormWizard />

            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="mt-5 card radius-15">
                        <div className="py-4 text-center border-bottom">
                            <h4 className="mb-0 text-primary display-4 event-form-title">Event Summary</h4>
                        </div>
                        <div className="py-5 m-3 card-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="py-2 ml-2 text">
                                            <p className="mb-0 uppercase font-size-16 text-primary">event name</p>
                                            <p className="capitalize font-size-14">{event_info.event_name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="py-2 ml-2 text">
                                            <p className="mb-0 uppercase font-size-16 text-primary">start Date</p>
                                            <p className="capitalize font-size-14">{event_info.event_start_date}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="py-2 ml-2 text">
                                            <p className="mb-0 uppercase font-size-16 text-primary">Finish Date</p>
                                            <p className="capitalize font-size-14">{event_info.event_end_date}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="py-2 ml-2 text">
                                            <p className="mb-0 uppercase font-size-16 text-primary">venue name</p>
                                            <p className="capitalize font-size-14">{event_info.event_venue_name}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="py-2 ml-2 text">
                                            <p className="mb-0 uppercase font-size-16 text-primary">password</p>
                                            <p className="capitalize font-size-14">{event_option.adminPassword}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="my-5 row justify-content-center">
                <div className="col-md-8">
                    <button type="button" onClick={() => history.goBack()} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>

                    {user && user.membership.package_type == 'single' ? (
                        <button type="button" onClick={handelPayWithSubmitEvent} className="float-right px-5 btn btn-primary radius-10">
                            {loading && loading ? (<span className="spinner-border spinner-border-sm" disabled role="status" aria-hidden="true"></span>)
                                : ("Save with Pay")}
                        </button>
                    ) :
                        <button type="button" onClick={handelSubmitEvent} className="float-right px-5 btn btn-primary radius-10">
                            {loading && loading ? (<span className="spinner-border spinner-border-sm" disabled role="status" aria-hidden="true"></span>)
                                : ("submit")}
                        </button>
                    }

                </div>
            </div>

        </Layout>
    )
}

export default EventSummary
